// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1-wwy","label":"Labeled_label__23qdO","divider":"Labeled_divider__2sDAQ"};